module.exports = __webpack_public_path__ + "img/reports.1b6df45.png";